import { parseAddressReference } from '../chunk-CJWMI5DQ.js';
import { normalizeAddress } from '../chunk-FFWAS4XO.js';
import '../chunk-AEYXO6NC.js';
import { normalizeCaip2 } from '../chunk-4L52XBJB.js';
import '../chunk-GPJ572YS.js';
import '../chunk-N7SZ66QO.js';
import '../chunk-PZ5AY32C.js';

// src/focus/index.ts
var NODE_PREFIX = {
  transaction: "tx",
  address: "addr",
  entity: "entity",
  label: "label",
  tag: "tag",
  group: "group"
};
function txNodeId(canonicalTxId) {
  return `${NODE_PREFIX.transaction}:${canonicalTxId}`;
}
function addressNodeId(chain, address) {
  const chainKey = chain.includes(":") ? normalizeCaip2(chain) : chain.trim().toLowerCase();
  return `${NODE_PREFIX.address}:${chainKey}:${normalizeAddress(address, chain)}`;
}
function entityNodeId(entityId) {
  return `${NODE_PREFIX.entity}:${entityId}`;
}
function focusNodeId(target) {
  switch (target.kind) {
    case "transaction":
      return txNodeId(target.id);
    case "address":
      return addressNodeId(target.chain ?? "", target.id);
    default:
      return `${NODE_PREFIX[target.kind]}:${target.id}`;
  }
}
function parseFocusNodeId(nodeId) {
  const firstColon = nodeId.indexOf(":");
  if (firstColon <= 0) return null;
  const prefix = nodeId.slice(0, firstColon);
  const rest = nodeId.slice(firstColon + 1);
  if (!rest) return null;
  const kind = Object.keys(NODE_PREFIX).find((k) => NODE_PREFIX[k] === prefix);
  if (!kind) return null;
  if (kind === "address") {
    if (rest.startsWith(":")) return { kind, chain: "", id: rest.slice(1) };
    const parsed = parseAddressReference(rest);
    return { kind, chain: parsed.chain ?? "", id: parsed.address };
  }
  return { kind, id: rest };
}
function sameFocusTarget(a, b) {
  if (!a || !b) return false;
  return focusNodeId(a) === focusNodeId(b);
}
function focusFromTransactionRow(row) {
  const id = row.canonical_tx_id ?? row.tx_hash;
  if (!id) return null;
  return { kind: "transaction", id, chain: row.chain_id ?? void 0 };
}
function focusAddress(chain, address, label) {
  return { kind: "address", chain, id: normalizeAddress(address, chain), label };
}
function focusEntity(entityId, label) {
  return { kind: "entity", id: entityId, label };
}

export { addressNodeId, entityNodeId, focusAddress, focusEntity, focusFromTransactionRow, focusNodeId, parseFocusNodeId, sameFocusTarget, txNodeId };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map